// extracted by mini-css-extract-plugin
export default {"footer_ipn":"footer_footer_ipn__0I6tE"};